import { useTranslation } from 'react-i18next';
// import { isLocaleEnglish } from 'utils/languageUtils';
import payment from 'assets/images/liHome/payment.svg';
import claims from 'assets/images/liHome/claims.svg';
import policyup from 'assets/images/liHome/policyup.svg';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { Col, Row, Badge, Divider, Grid } from 'antd';
import { Fragment } from 'react';
const { useBreakpoint } = Grid;
import './MakerTab.less';
const tabs = [
  { name: 'payment', url: 'LIPayment', img: payment },
  { name: 'policyup', url: 'MakeRequestPage', img: policyup },
  { name: 'claims', url: 'ClaimEnquiryPage', img: claims },
];
const alertKeys = ['alert1', 'alert2', 'alert3'] as const;
// type AlertKey = typeof alertKeys[number];
type MakerTabProps = {
  alerts?: { alert1?: number; alert2?: number; alert3?: number } | undefined;
};
const StyledDivider = styled(Divider)`
  margin-top: 13px;
  height: 64px;
`;

export const MakerTab = ({ alerts }: MakerTabProps) => {
  const {
    t,
    // ,i18n
  } = useTranslation();
  const navigateTo = useNavigate();
  const { xs, lg } = useBreakpoint();
  const toPath = (url: string, index: number) => {
    if (index == 2) {
      navigateTo('/' + url, { state: { alerts: alerts?.[alertKeys[index]] } });
    } else navigateTo('/' + url);
  };
  // const isEnglish = isLocaleEnglish(i18n.language);
  const tabList = tabs.map((tab, index) => {
    return (
      <Fragment key={index}>
        <Col className={`maker${index + 1}`} style={{ width: '30%' }}>
          {/* {tab.name == 'payment' ? ( */}
          <Badge count={alerts?.[alertKeys[index]] || 0} offset={[index == 2 ? -30 : 0, 0]}>
            <div
              className="mark-wrap mark-wrap1"
              style={{
                width: '100%',
                margin: `${xs && tab.name == 'claims' ? 'auto' : 0}`,
                cursor: 'pointer',
              }}
              onClick={() => toPath(tab.url, index)}
            >
              {/* <Row justify="center" align="middle" style={{ width: '40%' }}>
                  <Col xs={24} lg={10} sm={10}> */}
              <img src={tab.img} style={{ width: lg ? '32px' : '24px', height: lg ? '32px' : '24px' }} alt="" />
              {/* </Col>
                  <Col xs={24} lg={10} sm={10}> */}
              <span className="desc" style={{ whiteSpace: `${xs ? 'pre-line' : 'nowrap'}` }}>
                {!xs ? t(`life.home.${tab.name}`).replace('\n', '') : t(`life.home.${tab.name}`)}
              </span>
              {/* </Col>
                </Row> */}
            </div>
          </Badge>
          {/* ) : (
            <div
              className={`mark-wrap mark-wrap${index + 1}`}
              style={{
                width: `${xs && tab.name == 'claims' ? '75%' : '100%'}`,
                margin: `${xs && tab.name == 'claims' ? 'auto' : 0}`,
                cursor: 'pointer',
              }}
              onClick={() => toPath(tab.url)}
            >
              <img
                src={tab.name == 'claims' ? claims : policyup}
                alt=""
                style={{
                  width: lg ? '32px' : '24px',
                  height: lg ? '32px' : '24px',
                }}
              />
              <span className="desc" style={{ whiteSpace: `${xs ? 'pre-line' : 'nowrap'}` }}>
                {!xs ? t(`life.home.${tab.name}`).replace('\n', '') : t(`life.home.${tab.name}`)}
              </span>
            </div>
          )} */}
        </Col>
        {index !== tabs.length - 1 && (
          <Col style={{ width: '5%' }}>
            <StyledDivider type="vertical" />
          </Col>
        )}
      </Fragment>
    );
  });

  return (
    <div className="marker-wrapper">
      <Row className="marker-tab">{tabList}</Row>
    </div>
  );
};
